module.exports = __webpack_public_path__ + "img/host3-sm.95953985.png";